var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"box"},[_c('nav-bar'),_c('home-content',{ref:"home_content"}),_c('software-home',{ref:"software_home"}),_c('resource-rank',{ref:"resource_rank"}),_c('bottom-slider')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }